import { makeAutoObservable } from 'mobx';
import { getAllInterCode } from '@src/service';
import { IAreaItem } from '@src/types';

export default class User {
  areaCodeList: IAreaItem[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  // 获取所有区号
  fetchAreaCodeList = async (filter) => {
    if (this.areaCodeList.length) {
      if (filter?.trim()) {
        return this.areaCodeList.filter((item) => `${item.name}(${item.id})`.includes(filter?.trim()));
      }
      return this.areaCodeList;
    }
    const data = await getAllInterCode({
      category: 'interCode',
      filter: '',
    });
    this.setAreaCodeList(data);
    return data;
  };

  // 设置区号
  setAreaCodeList = (payload) => {
    this.areaCodeList = payload;
  };
}
